module.exports = __webpack_public_path__ + "static/media/7.237643a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/01/projects/01/7.jpg
// module id = 398
// module chunks = 0